// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomFiSrSmileWink = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '20',
      height: '20',
      viewBox: '0 0 20 20',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        id: 'fi-sr-smile-wink',
        clipPath: 'url(#clip0_613_4942)',
      },
      /*#__PURE__*/ React.createElement('path', {
        id: 'Vector',
        d: 'M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0V0ZM5.83334 7.5H8.33334C8.55435 7.5 8.76631 7.5878 8.92259 7.74408C9.07887 7.90036 9.16667 8.11232 9.16667 8.33333C9.16667 8.55435 9.07887 8.76631 8.92259 8.92259C8.76631 9.07887 8.55435 9.16667 8.33334 9.16667H5.83334C5.61232 9.16667 5.40036 9.07887 5.24408 8.92259C5.0878 8.76631 5 8.55435 5 8.33333C5 8.11232 5.0878 7.90036 5.24408 7.74408C5.40036 7.5878 5.61232 7.5 5.83334 7.5ZM14.7217 13.1217C13.3984 14.2521 11.7382 14.9126 10 15C8.26185 14.9126 6.60156 14.2521 5.27834 13.1217C5.11346 12.9745 5.01381 12.7678 5.00131 12.5471C4.99512 12.4379 5.01051 12.3285 5.0466 12.2251C5.0827 12.1218 5.13879 12.0266 5.21167 11.945C5.28455 11.8634 5.3728 11.7969 5.47138 11.7493C5.56996 11.7018 5.67693 11.6742 5.7862 11.668C6.00687 11.6555 6.22346 11.7311 6.38834 11.8783C7.40686 12.7351 8.67202 13.2448 10 13.3333C11.3288 13.2447 12.5946 12.7344 13.6133 11.8767C13.6951 11.8039 13.7904 11.7479 13.8937 11.712C13.9971 11.676 14.1066 11.6608 14.2158 11.6671C14.3251 11.6735 14.432 11.7013 14.5305 11.749C14.6291 11.7966 14.7172 11.8633 14.79 11.945C14.8628 12.0267 14.9187 12.122 14.9547 12.2254C14.9906 12.3288 15.0059 12.4382 14.9995 12.5475C14.9932 12.6567 14.9654 12.7637 14.9177 12.8622C14.87 12.9607 14.8034 13.0489 14.7217 13.1217ZM13.3333 9.16667C12.4125 9.16667 11.6667 9.16667 11.6667 8.33333C11.6667 7.89131 11.8423 7.46738 12.1548 7.15482C12.4674 6.84226 12.8913 6.66667 13.3333 6.66667C13.7754 6.66667 14.1993 6.84226 14.5118 7.15482C14.8244 7.46738 15 7.89131 15 8.33333C15 9.16667 14.2542 9.16667 13.3333 9.16667Z',
        fill: 'currentColor',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_613_4942',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: '20',
          height: '20',
          fill: 'white',
        }),
      ),
    ),
  );

export { IconCustomFiSrSmileWink };
